import { render } from "./concise.vue?vue&type=template&id=007d6167&scoped=true"
import script from "./concise.vue?vue&type=script&lang=js"
export * from "./concise.vue?vue&type=script&lang=js"

import "./concise.vue?vue&type=style&index=0&id=007d6167&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007d6167"]])

export default __exports__